import { InputsFinalize } from "../components/FinalizePage/FinalizeNoLogin";
import { FinalizeRecipient } from "./FinalizeRecipient";

export interface SaveData {
  name: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  countryCode?: string;
  recipient?: FinalizeRecipient;
  purchaser?: FinalizeRecipient;
}

export const setSaveData = (data: InputsFinalize) => {
  return {
    name: data.firstName ?? "",
    lastName: data.lastName ?? "",
    email: data.email ?? "",
    phone: data.phone ?? "",
    city: data.city ?? "",
    street: data.street ?? "",
    houseNumber: data.houseNumber ?? "",
    flatNumber: data.flatNumber ?? "",
    zipCode: data.zipCode ?? "",
    NIP: data.NIP ?? "",
    companyName: data.companyName ?? "",
    createUser: data.createUser ?? false,
    createInvoice: data.createInvoice,
    countryCode: data.nipCountryCode || undefined,
    // Nie podstawiamy tu pustego obiektu jako fallback — niektóre endpointy (np.
    // assignPass/transaction) walidują `recipient`/`purchaser` kaskadowo, jeśli pole
    // jest w ogóle obecne w JSON-ie, nawet puste. Zostają undefined, żeby JSON.stringify
    // je pominął, gdy formularz faktury "odbiorca+nabywca" nigdy się nie renderował.
    recipient: data.recipient,
    purchaser: data.purchaser,
  } as SaveData;
};
